<template>
  <p image-asset :style="{backgroundColor:bgColor}">
    <img v-if="url" :src="source" :alt="alt" :style="{ objectFit: fit }" />
  </p>
</template>

<script>
import { getCloudFileUrl } from '@/utils/url';
import { checkUrl } from '@/utils/url';

export default {
  name: 'ImageAsset',
  props: {
    url: String,
    alt: { type: String, default: 'lvup image' },
    fit: { type: String, default: 'cover' },
    bgColor: { type: String, default: 'grey' },
  },
  computed: {
    source() {
      if (/img/.test(this.url)) return this.url;
      if (this.url === '' || !this.url) return '';
      if (checkUrl(this.url)) return this.url;
      return getCloudFileUrl(this.url);
    },
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';
[image-asset] {.w(100%);overflow: hidden;.br(20);object-position: center;display: inline-flex;
  img {.wh(100%);}
}
</style>
